import { createContext } from 'react';
export const ToastContext = createContext(null);
//# sourceMappingURL=ToastContext.js.map